/**
 * A competency's state, as a word.
 *
 * This component is the reason invariant 1 holds on the child side: it is the
 * only way the shell renders mastery, and it takes a state — not a score. There
 * is no numeric prop to pass by accident.
 */

import { CHILD_STATE_LABEL, PARENT_STATE_LABEL, type MasteryState } from "@/config/wording";

export function StateChip({
  state,
  audience,
}: {
  state: MasteryState;
  audience: "child" | "parent";
}) {
  const label = audience === "child" ? CHILD_STATE_LABEL[state] : PARENT_STATE_LABEL[state];
  return (
    <span className={`chip chip--${state}`} data-state={state}>
      {label}
    </span>
  );
}

/**
 * The four states as a track, so a child can see where a competency sits and
 * where it is going. Still no number: position, not measurement.
 */
export function StateTrack({ state }: { state: MasteryState }) {
  const steps: MasteryState[] = ["fragile", "en_cours", "acquis", "consolide"];
  const reached = steps.indexOf(state);
  return (
    <ol className="track" aria-label={`état : ${CHILD_STATE_LABEL[state]}`}>
      {steps.map((step, index) => (
        <li
          key={step}
          className="track__step"
          data-reached={reached >= index ? "true" : "false"}
          data-current={reached === index ? "true" : "false"}
        >
          <span className="track__dot" aria-hidden="true" />
          <span className="track__label">{CHILD_STATE_LABEL[step]}</span>
        </li>
      ))}
    </ol>
  );
}
